import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.DELIVERY_REVIEW]: {
    [ROLE.TEXT]: [ELEMENT.ADDRESS, ELEMENT.PRODUCT],
    [ROLE.BUTTON]: [ELEMENT.CHANGE, ELEMENT.CONTINUE],
    [ROLE.CARD]: [ELEMENT.CART_ITEM],
  },
  [CONTEXT.DELIVERY_ZIPCODE]: {
    [ROLE.FORM]: [ELEMENT.ZIPCODE],
    [ROLE.TEXTBOX]: [ELEMENT.ZIPCODE],
    [ROLE.BUTTON]: [ELEMENT.CONFIRM, ELEMENT.CANCEL],
    [ROLE.LINK]: [ELEMENT.ZIPCODE],
  },
  [CONTEXT.DELIVERY_FORM]: {
    [ROLE.FORM]: [ELEMENT.ADDRESS],
    [ROLE.SWITCH]: [ELEMENT.NUMBER],
    [ROLE.CHECKBOX]: [ELEMENT.BILLING_ADDRESS],
    [ROLE.BUTTON]: [ELEMENT.CONFIRM, ELEMENT.CANCEL],
  },
  [CONTEXT.DELIVERY_LIST]: {
    [ROLE.CONTAINER]: [ELEMENT.ADDRESS],
    [ROLE.TEXT]: [ELEMENT.ACTION_BOX],
  },
  [CONTEXT.DELIVERY_ADDRESS]: {
    [ROLE.RADIO]: [ELEMENT.ADDRESS],
    [ROLE.TEXT]: [ELEMENT.ADDRESS, ELEMENT.DEFAULT],
    [ROLE.BUTTON]: [ELEMENT.EDIT, ELEMENT.NEW, ELEMENT.CONFIRM],
  },
} as TValidTestId;
